import { styled as s, Box as l, Typography as g, useMediaQuery as h } from "@mui/material";
import { useCurrencyContext as y } from "../../currency-lib/contexts/CurrencyContext.js";
import k from "../../temp-lib/styles/theme.js";
import { noForwardProps as b, noForwardCustomProps as T } from "../../temp-lib/util/styled/index.js";
import d from "./Token.js";
import * as a from "ramda";
import { useMemo as w } from "react";
import { jsxs as C, jsx as n } from "react/jsx-runtime";
const N = s(l, b)`
  background: var(--inventory-buttons, #31333f);
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 175px;
  padding: 10px 20px;

  ${(o) => o.__displayOne && "align-items: center;"}
`, M = s(g, T(["color"]))`
  color: ${(o) => o.color || "white"};
  font-weight: 700;
`, B = s(l)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;

  .Custom-Token:last-child {
    border-right: unset;
    padding-right: unset;
  }
`, _ = s(l)`
  border-right: 1px solid #7d7e7f;
  padding-right: 16px;
`, j = s(d)`
  max-width: 120px;
`, c = (o) => {
  const {
    token: e
  } = o, {
    getApeironPrice: m
  } = y(), i = h(k.breakpoints.down("res1280")) ? j : d;
  return /* @__PURE__ */ n(_, {
    className: "Custom-Token",
    children: /* @__PURE__ */ n(i, {
      amount: m(e.type, e.amount, {
        maxDecimal: 4,
        maxLength: 6
      }),
      iconUrl: e.image,
      unit: e.name
    })
  }, e.name);
}, E = (o) => {
  const {
    className: e,
    title: m,
    tokens: t,
    displayOne: i = !1
  } = o, u = w(() => a.reduce((r, p) => {
    const x = p.amount || "0", f = r.amount || "0";
    return Number(x) > Number(f) ? p : r;
  }, a.head(t), t), [t]);
  return a.isNotEmpty(t) ? /* @__PURE__ */ C(N, {
    __displayOne: i,
    className: e,
    children: [/* @__PURE__ */ n(M, {
      className: "Custom-Title",
      children: m
    }), /* @__PURE__ */ n(B, {
      className: "Custom-Token-Box",
      children: i ? /* @__PURE__ */ n(c, {
        token: u
      }) : a.map((r) => /* @__PURE__ */ n(c, {
        token: r
      }, r.name), t)
    })]
  }) : null;
};
export {
  E as default
};
//# sourceMappingURL=TokenSection.js.map
